module.exports = __webpack_public_path__ + "img/kt02.c26295ea.jpg";